module.exports = __webpack_public_path__ + "img/faceberry_eye.afdbd662.png";